import { IResourceComponentsProps } from "@refinedev/core";
import CollecteFormWrapper from "../../components/collecte/CollecteFormWrapper";

const CollecteEdit: React.FC<IResourceComponentsProps> = () => {
  return <CollecteFormWrapper action="edit" />;
};

export default CollecteEdit;
